/** Build a display name from first + last, falling back to email */
export function getDisplayName(user: { firstName?: string | null; lastName?: string | null; email: string }): string {
  return user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.email;
}

/** Extract up to 2 uppercase initials from a name string */
export function getInitials(name: string): string {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}
